<template>
<div>
    <NavBar/>
    <div v-if="!isMobile()">
        <button v-if="!approvedCut && !loadingTransaction" class="button-36" @click="approveMerge()">APPROVE YIELD SYSTEM</button>
        <button v-if="approvedCut && !firstClaim && !loadingTransaction" class="button-36" @click="claimCutBonus()">MERGE + BONUS CUT</button>
        <b-icon class="middleScreen" v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>


        <img class="rewards" src="../assets/pages/rewards.jpg" alt="" usemap="#image-mapRewards">
        <map name="image-mapRewards">
            <area class="areaClick" target="" @click="openGenModal()" alt="genesis" title="genesis" coords="77,334,481,453" shape="rect">
            <area class="areaClick" target="" @click="openFusionModal()" alt="fusion" title="fusion"  coords="1461,331,1865,451" shape="rect">
        </map>
    </div>

    <b-modal size="xl" ref="modal-1" hide-footer title="Genesis Claim" v-if="clabsNftById.length > 0">
            
            <b-container>
                <b-row>
                    <b-col cols="12">
                        
                        <br><br>
                        <h4 class="centerTxt" v-if="clabsNftById.length > 0">SELECT DUCKS FOR CLAIM <br>CUT BALANCE IN WALLET : {{cutBalance}}</h4>
                        <br><br>
                        <div v-for="(id) in clabsNftById" :key="id">
                            <a @click="addNft(id)" v-if="id <= 1000" class="cardClick"><b-card
                                :title="'Genesis #' + id"
                                tag="duck"
                                name="Ducks"
                                class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs"
                                :id="'duck' + id"
                            >
                            <img  class="imageOfDuck" :src="genesisIPFS + id + '.gif'" alt="">
                            </b-card></a>
                        </div>

                        <br><br><br><br>
                        <br><br><br><br>
                        <br><br><br><br>
                        <br><br><br><br>
                        <br><br>
                        <button class="button-35" @click="SelectAllGens()">SELECT ALL</button>
                        <br><br>
                        <button class="button-35" @click="UnselectAllGens()">UNSELECT ALL</button>         
                        <br><br>
                        <button v-if="clabsSelectedNFTsToClaim.length > 0" class="button-35" @click="claimCutClabs()">CLAIM</button>
                        <br><br>
                        <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                        <h4 v-if="clabsSelectedNFTsToClaim.length > 0">Total Cut Earned : {{Number(totalCut).toFixed(4)}}</h4>
                    </b-col>
                </b-row>
            </b-container>
            
        </b-modal>



        <b-modal size="xl" ref="modal-2" hide-footer title="Fusion Claim" v-if="fusionNftById.length > 0">
            
            <b-container>
                <b-row>
                    <b-col cols="12">
                        <br><br>
                        <h4 class="centerTxt"  v-if="fusionNftById.length > 0">SELECT FUSIONS FOR CLAIM <br>CUT BALANCE IN WALLET : {{cutBalance}}</h4>
                        <br><br>
                        <div v-for="(id) in fusionNftById" :key="id">
                            <a @click="addNftFusion(id)" class="cardClick"><b-card
                                :title="'Fusion #' + id"
                                tag="duck"
                                class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs"
                                :id="'fusion' + id"
                            >
                            <img  class="imageOfDuck" :src="fusionIPFS" alt="">
                            </b-card></a>
                        </div>

                        <br><br><br><br>
                        <br><br><br><br>
                        <br><br>
                        <button class="button-35" @click="SelectAllFusion()">SELECT ALL</button>
                        <br><br>
                        <button class="button-35" @click="UnselectAllFusion()">UNSELECT ALL</button>   
                        <br><br>
                        <button v-if="fusionSelectedNFTsToClaim.length > 0 && !loadingTransaction" class="button-35" @click="claimCutFusion">CLAIM</button>
                        <br><br>
                        <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                        <h4 v-if="fusionSelectedNFTsToClaim.length > 0">Total Cut Earned : {{Number(totalCut).toFixed(4)}}</h4>
                    </b-col>
                </b-row>
            </b-container>
            
        </b-modal>

    
    <div v-if="isMobile()">
        <button v-if="!approvedCut && !loadingTransaction" class="button-37" @click="approveMerge()">APPROVE YIELD SYSTEM</button>
        <button v-if="approvedCut && !firstClaim && !loadingTransaction" class="button-37" @click="claimCutBonus()">MERGE + BONUS CUT</button>
        <b-icon class="middleScreenMobile" v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
        <img class="rewardsMobile" src="../assets/mobile/claim.jpg" alt="" usemap="#image-mapMobile">
        <map name="image-mapMobile">
            <area @click="openFusionModal()" target="" alt="fusion" title="fusion" coords="243,369,843,566" shape="rect">
            <area @click="openGenModal()" target="" alt="genesis" title="genesis" coords="244,592,846,769" shape="rect">    
        </map>
    </div>
    <Footer/>
</div>
</template>

<script>
import NavBar from './Navigation/NavBar.vue'
import Web3 from 'web3';
import Footer from './Navigation/Footer.vue'
import newCut from '../assets/contracts/newCut.json'
import oldCut from '../assets/contracts/oldCut.json'
import clabs from '../assets/contracts/clabs.json'
import fusion from '../assets/contracts/fusion.json'

export default {
    components:{
        NavBar,
        Footer
    },
    created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
    data: function () {
            return {
                web3: '',

                walletAddress: '',
                walletBalance: '',
                cutBalance: 0,
                oldCutBalance: 0,

                firstClaim: false,
                loadingTransaction: false,

                cosmiclabsContract: '',
                contractAbi: clabs.abi,
                contractAddress: clabs.contractAddress,

                fusionContract: '',
                fusionContractAbi: fusion.abi,
                fusionContractAddress: fusion.contractAddress,

                newTokenContract: '',
                newTokenContractAbi: newCut.abi,
                newTokenContractAddress: newCut.contractAddress,

                oldCutContract: '',
                oldCutAbi: oldCut.abi,
                oldCutAddress: oldCut.contractAddress,

                clabsNftById: [],
                clabsSelectedNFTsToClaim: [],

                fusionNftById: [],
                fusionSelectedNFTsToClaim: [],

                approvedCut: false,

                totalCut: 0,

                genesisIPFS: 'https://cosmiclabs.mypinata.cloud/ipfs/QmctzpRxLg9Tk5nTgsczAy6W4reeN85n3BDohT27bEdRib/',
                fusionIPFS: 'https://cosmiclabs.mypinata.cloud/ipfs/QmWHnT5QnVd3N2LwduDsWA9bH9nGpGxe9mh75efPax86GE',

            }
    },
    mounted()
    {
        $(document).ready(function(e) {
            $('img[usemap]').rwdImageMaps();
        });

        this.LoadEthWallet(); 
        
    },
    methods:
    {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        openGenModal()
        {
            if(this.clabsNftById.length > 0)
            {
                this.totalCut = 0;
                this.clabsSelectedNFTsToClaim = [];
                this.fusionSelectedNFTsToClaim = [];
                this.$refs['modal-1'].show();
            }
            else
            {
                alert("You don't have any Genesis Ducks!");
            }
        },
        openFusionModal()
        {
            if(this.fusionNftById.length > 0)
            {
                this.totalCut = 0;
                this.clabsSelectedNFTsToClaim = [];
                this.fusionSelectedNFTsToClaim = [];
                this.$refs['modal-2'].show();
            }
            else
            {
                alert("You don't have any Fusion Ducks!");
            }
        },
        checkAmountClabs()
        {
            this.newTokenContract.methods.tokensAccumulated(this.clabsSelectedNFTsToClaim).call({})
            .then(res=>{
                this.totalCut = this.web3.utils.fromWei(res, 'ether')
                
            })
        },
        checkAmountFusion()
        {
            this.newTokenContract.methods.getPendingTokensManyFusion(this.fusionSelectedNFTsToClaim).call({})
            .then(res=>{
                this.$refs['modal-2'].show()
                this.totalCut = this.web3.utils.fromWei(res, 'ether')
                
            })
        },
        claimCutClabs()
        {
            this.loadingTransaction = true;
            this.newTokenContract.methods.claimRewards(this.clabsSelectedNFTsToClaim).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.checkAmountClabs();
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        claimCutFusion()
        {
            this.loadingTransaction = true;
            this.newTokenContract.methods.claimFusion(this.walletAddress, this.fusionSelectedNFTsToClaim).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.checkAmountFusion();
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        addNft(id)
        {
            var exists = false;
            var existingId;
            for(var i=0; i<this.clabsSelectedNFTsToClaim.length;i++)
            {
                if(this.clabsSelectedNFTsToClaim[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }
            if(!exists)
            {
                this.clabsSelectedNFTsToClaim.push(id);
                document.getElementById('duck' + id).style.background = "#bc33ed";
                this.checkAmountClabs();
            }
            else
            {
                this.clabsSelectedNFTsToClaim.splice(existingId,1);
                document.getElementById('duck' + id).style.background = "none";
                this.checkAmountClabs();
            }

        },
        SelectAllGens()
        {   
            this.clabsSelectedNFTsToClaim = [];
            for(var i=0;i<this.clabsNftById.length;i++)
            {
                this.clabsSelectedNFTsToClaim.push(this.clabsNftById[i]);
                document.getElementById('duck' + this.clabsNftById[i]).style.background = "#bc33ed";
            }
            this.checkAmountClabs();
        },
        UnselectAllGens()
        {   
            this.clabsSelectedNFTsToClaim = [];
            for(var i=0;i<this.clabsNftById.length;i++)
            {
                document.getElementById('duck' + this.clabsNftById[i]).style.background = "none";
            }
            this.checkAmountClabs();
            
        },
        addNftFusion(id)
        {
            var exists = false;
            var existingId;
            for(var i=0; i<this.fusionSelectedNFTsToClaim.length;i++)
            {
                if(this.fusionSelectedNFTsToClaim[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }
            if(!exists)
            {
                this.fusionSelectedNFTsToClaim.push(id);
                document.getElementById('fusion' + id).style.background = "#45e529";
                this.checkAmountFusion();
            }
            else
            {
                this.fusionSelectedNFTsToClaim.splice(existingId,1);
                document.getElementById('fusion' + id).style.background = "none";
                this.checkAmountFusion();
            }
        },
        SelectAllFusion()
        {   
            this.fusionSelectedNFTsToClaim = [];
            for(var i=0;i<this.fusionNftById.length;i++)
            {
                this.fusionSelectedNFTsToClaim.push(this.fusionNftById[i]);
                document.getElementById('fusion' + this.fusionNftById[i]).style.background = "#45e529";
            }
            this.checkAmountFusion();
        },
        UnselectAllFusion()
        {   
            this.fusionSelectedNFTsToClaim = [];
            for(var i=0;i<this.fusionNftById.length;i++)
            {
                document.getElementById('fusion' + this.fusionNftById[i]).style.background = "none";
            }
            this.checkAmountFusion();
        },
        claimCutBonus()
        {
            this.loadingTransaction = true;
            this.newTokenContract.methods.migrateCut().send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.loadTokenInfo();
                
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        approveMerge()
        {
            if(this.oldCutBalance > 0)
            {
                this.loadingTransaction = true;
                const weiValue = this.web3.utils.toWei('10000000', 'ether');
                
                this.oldCutContract.methods.approve(this.newTokenContractAddress, weiValue.toString()).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.loadingTransaction = false;
                    this.loadTokenInfo();
                })
                .catch(err=>{
                    this.loadingTransaction = false;
                })
            }
            else
            {
                alert("You don't have old cut to merge!");
            }

        },
        LoadEthWallet: function(){
            if (typeof window.ethereum !== 'undefined') 
            {
                this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                this.web3.eth.net.getNetworkType()
                .then(network=>{
                    if(network == "main")
                    {
                        this.web3.eth.requestAccounts()
                        .then(acc=>{
                            this.walletAddress = acc[0];
                            this.web3.eth.getBalance(this.walletAddress)
                            .then(balance=>{
                                this.walletBalance = this.web3.utils.fromWei(balance, "ether");  
                                this.loadTokenInfo();
                                
                            });
                        })
                        .catch(err=>{
                            console.log(err);
                        })                                   
                    }
                    else{
                        this.chainChange();
                    }          
                })
            }
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },
        loadTokenInfo: function()
        {
            this.clabsNftById = [];
            this.cosmiclabsContract = new this.web3.eth.Contract(this.contractAbi, this.contractAddress);
            this.cosmiclabsContract.methods.walletOfOwner(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                for(var i=0; i<res.length;i++)
                {
                    if(res[i] <= 1000)
                    {
                        this.clabsNftById.push(res[i]);  
                    }   
                }
                          
            })
            this.fusionNftById = [];
            this.fusionContract = new this.web3.eth.Contract(this.fusionContractAbi, this.fusionContractAddress);
            this.fusionContract.methods.walletOfOwner(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                this.fusionNftById = res;            
            })


            this.oldCutContract = new this.web3.eth.Contract(this.oldCutAbi, this.oldCutAddress);
            this.oldCutContract.methods.balanceOf(this.walletAddress).call({})
            .then(res=>{
                this.oldCutBalance = this.web3.utils.fromWei(res, 'ether');
            })


            this.oldCutContract.methods.allowance(this.walletAddress, this.newTokenContractAddress).call({})
            .then(res=>{
                if(res >= 1000000000000000000000000)
                {
                    this.approvedCut = true;
                }
            })

            this.newTokenContract = new this.web3.eth.Contract(this.newTokenContractAbi, this.newTokenContractAddress);
            this.newTokenContract.methods.firstClaim(this.walletAddress).call({})
            .then(res=>{
                this.firstClaim = res;
            })
            this.newTokenContract.methods.balanceOf(this.walletAddress).call({})
            .then(res=>{
                this.cutBalance = this.web3.utils.fromWei(res, 'ether');
            })
        }

    },
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.loadTokenInfo();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.loadTokenInfo();
            })
            
          },
    },
}
</script>

<style scoped>
.notAvail
{
    margin-top: 20vh;
    color: white;
    font-size: 3vh;
}
.middleScreen
{
    position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.middleScreenMobile
{
    position: absolute;
  top: 12%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.rewardsMobile
{
    width: 100%;
}
.rewards
{
    width: 100%;
}
.areaClick
{
    cursor: pointer;
}
.imageOfDuck
{
    width: 100%;
    margin-top:auto
}
.card-title {
    margin-bottom: 0.5rem;
    font-size: 2vh;
}
.button-34 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  margin: 0;
  position: absolute;
  top: 25%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.button-35 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
}

.button-36 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.button-37 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.clabs
{
    width: 20vh;
    float: left;
    margin-left: 2vh;
    display: flex !important;
    margin-bottom: 2vh;
}
.cardClick
{
    text-decoration: none;
    color: black;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/Claim.vue